import React from 'react';
import BlogLayout from '../Blog/BlogLayout';

export default function Contato() {
  return (
    <BlogLayout title="Contato" description="Entre em contato com a equipe do Integra MKP. Suporte, dúvidas e sugestões.">
      <div style={{ maxWidth: 700, margin: '0 auto', padding: '64px 24px 100px' }}>
        <h1 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 900, fontSize: 44, letterSpacing: '-0.03em', color: '#0E1430', marginBottom: 8 }}>Contato</h1>
        <div style={{ width: 60, height: 4, background: 'linear-gradient(90deg, #FFD400, #E63946, #2E7DE0)', borderRadius: 2, marginBottom: 40 }} />

        <div style={{ display: 'grid', gap: 20 }}>
          {[
            { icon: '✉️', title: 'E-mail geral', desc: 'Dúvidas, sugestões, parcerias', value: 'integra.mplace@gmail.com', href: 'mailto:integra.mplace@gmail.com' },
            { icon: '🛠️', title: 'Suporte técnico', desc: 'Problemas com a plataforma', value: 'integra.mplace@gmail.com', href: 'mailto:integra.mplace@gmail.com?subject=Suporte' },
            { icon: '💰', title: 'Financeiro / assinatura', desc: 'Dúvidas sobre pagamento ou cancelamento', value: 'integra.mplace@gmail.com', href: 'mailto:integra.mplace@gmail.com?subject=Financeiro' },
          ].map(item => (
            <a key={item.title} href={item.href} style={{ textDecoration: 'none', display: 'flex', gap: 18, background: '#fff', border: '1px solid #E4E0D4', borderRadius: 14, padding: 24, transition: 'box-shadow 0.15s' }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 16px rgba(10,15,50,0.08)'}
              onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
            >
              <span style={{ fontSize: 28 }}>{item.icon}</span>
              <div>
                <div style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 700, fontSize: 17, color: '#0E1430', marginBottom: 4 }}>{item.title}</div>
                <div style={{ fontSize: 14, color: '#9CA3AF', marginBottom: 6 }}>{item.desc}</div>
                <div style={{ fontSize: 15, color: '#1B2A7A', fontWeight: 600 }}>{item.value}</div>
              </div>
            </a>
          ))}
        </div>

        <div style={{ background: '#F0F4FF', borderRadius: 14, padding: 28, marginTop: 40 }}>
          <h2 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: 20, color: '#1B2A7A', marginBottom: 10 }}>Horário de atendimento</h2>
          <p style={{ fontSize: 15, color: '#3B4266', lineHeight: 1.6, margin: 0 }}>
            Segunda a sexta, das 9h às 18h (horário de Brasília).<br />
            Tempo médio de resposta: até 24 horas úteis.
          </p>
        </div>
      </div>
    </BlogLayout>
  );
}
